/* stf-slide-banners.js — scroll-snap carousel with autoplay (v4 2026-07-11).
   Autoplay pauses on hover/focus/touch, off-screen (IntersectionObserver) and
   for prefers-reduced-motion. Dots + arrows drive scrollTo; scroll position
   syncs the active dot. */
(function () {
  'use strict';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.sbInit) return;
    root.dataset.sbInit = 'true';

    var track = root.querySelector('[data-slidebn-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slidebn-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slidebn-dot]'));
    if (!track || slides.length < 2) return;

    var idx = 0, timer = null, visible = true, engaged = false;
    var delay = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;

    function goTo(i, smooth) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function syncDots() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      slides.forEach(function (s, i) {
        if (mid >= s.offsetLeft && mid < s.offsetLeft + s.offsetWidth) idx = i;
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function tick() { if (visible && !engaged) goTo(idx + 1); }
    function start() {
      if (reducedMotion || !delay) return;
      stop(); timer = window.setInterval(tick, delay);
    }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    var prev = root.querySelector('[data-slidebn-prev]');
    var next = root.querySelector('[data-slidebn-next]');
    if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    var scrollRaf = null;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () { syncDots(); scrollRaf = null; });
    }, { passive: true });

    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      root.addEventListener(ev, function () { engaged = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (ev) {
      root.addEventListener(ev, function () { engaged = false; }, { passive: true });
    });
    track.addEventListener('touchend', function () {
      window.setTimeout(function () { engaged = false; }, 4000);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.3 }).observe(root);
    }

    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-slide-banners]').forEach(init);
  }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
